module.exports = __webpack_public_path__ + "static/media/user_big.90286ff0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_big.svg
// module id = 604
// module chunks = 0